import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

interface BreadcrumbItem {
    name: string;
    url?: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
    className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '' }) => {
    if (!items || items.length <= 1) {
        return null;
    }

    return (
        <Breadcrumb
            className={`custom-breadcrumbs ${className}`}
            separator="/"
            items={items.map((item, index) => ({
                title: item.url && index !== items.length - 1 ? (
                    <Link to={item.url}>{item.name}</Link>
                ) : (
                    <span>{item.name}</span>
                )
            }))}
        />
    );
};

export const getPageBreadcrumbs = (pathname: string): BreadcrumbItem[] => {
    const base = [{ name: 'Главная', url: '/' }];
    
    const pathMap: Record<string, BreadcrumbItem[]> = {
        '/bouquets': [{ name: 'Каталог', url: '/bouquets' }],
        '/catalog': [{ name: 'Каталог', url: '/bouquets' }],
        '/about': [{ name: 'О нас', url: '/about' }],
        '/dostavka-ufa': [{ name: 'Доставка', url: '/dostavka-ufa' }],
        '/dostavka-bulgakovo': [{ name: 'Доставка', url: '/dostavka-bulgakovo' }],
        '/bukety-na-zakaz': [{ name: 'Букеты на заказ', url: '/bukety-na-zakaz' }],
        '/svadebnaya-floristika': [{ name: 'Свадебная флористика', url: '/svadebnaya-floristika' }],
        '/komnatnye-rasteniya': [{ name: 'Растения', url: '/komnatnye-rasteniya' }],
        '/blog': [{ name: 'Блог', url: '/blog' }],
    };

    const extra = pathMap[pathname] || [];
    return [...base, ...extra];
};